import { CORE_BASIC_SERVICE_URI, CORE_SEARCH_SERVICE_URI, LAB_SERVICE_URI, ACCOUNT_SERVICE_URI, EUREKA_SERVICE_URI, WORKSPACE_SERVICE_URI } from './config';

function resolveApiUrlPrefix(
    defaultUrlPrefix: string,
    localUrlPrefix: string,
    useLocalApi: boolean,
): string {
    return import.meta.env.DEV && useLocalApi ? localUrlPrefix : defaultUrlPrefix;
}

export const coreBasicApiUrlPrefix = `${CORE_BASIC_SERVICE_URI}/core-basic-api`;
export const coreTelecomApiUrlPrefix = resolveApiUrlPrefix(
    `${CORE_SEARCH_SERVICE_URI}/core-telecom-api/telecom`,
    'http://127.0.0.1:8080/telecom',
    !!import.meta.env.VITE_USE_LOCAL_TELECOM_API,
);
export const noveltyAiSearchApiUrlPrefix = resolveApiUrlPrefix(
    `${CORE_SEARCH_SERVICE_URI}/novelty-search/v2/novelty`,
    'http://127.0.0.1:8000/v2/novelty',
    !!import.meta.env.VITE_USE_LOCAL_NOVELTY_API,
);
export const designFtoApiUrlPrefix = `${CORE_SEARCH_SERVICE_URI}/fto-image-api/fto-image`;
export const ftoProApiUrlPrefix = `${EUREKA_SERVICE_URI}/ai-patent-agent/fto_pro`;
export const eurekaApiUrlPrefix = `${EUREKA_SERVICE_URI}/eureka`;
export const agentApiUrlPrefix = `${EUREKA_SERVICE_URI}/ai-agent-api`;
export const hiroIpApiUrlPrefix = resolveApiUrlPrefix(
    `${CORE_SEARCH_SERVICE_URI}/core-hiro-ip-api`,
    '/core-hiro-ip-api',
    !!import.meta.env.VITE_USE_LOCAL_HIRO_IP_API,
);
export const coreSearchApiUrlPrefix = `${CORE_SEARCH_SERVICE_URI}/core-search-api/search`;
export const labServiceApiUrlPrefix = `${LAB_SERVICE_URI}/lab-service`;
export const accountServiceApiUrlPrefix = `${ACCOUNT_SERVICE_URI}/user-service`;
export const workspaceServiceApiUrlPrefix = `${WORKSPACE_SERVICE_URI}/workspace`;
export const assistantApiUrlPrefix = `${CORE_SEARCH_SERVICE_URI}/skill-chat`;
